import { render, staticRenderFns } from "./updateInfo.vue?vue&type=template&id=71847600&"
import script from "./updateInfo.vue?vue&type=script&lang=js&"
export * from "./updateInfo.vue?vue&type=script&lang=js&"
import style0 from "./updateInfo.vue?vue&type=style&index=0&id=71847600&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports